import { AppData } from '../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';
import { ApiRequestModel } from '../models/api_request_model';
import {
  CareUnitInfoRequest,
  ShiftTypeInfoRequest, ShiftAllocPatternRequest, ShiftAllocMasterRequest,
  ShiftAllocationRequest, JobIdentificationRequest, JobOrderRequest, JobApplicationRequest,
  JobApplicationTrackRequest, JobOfferRequest, StaffTypeInfoRequest, JobOrdersBetweenDateRequest,
  RegistryOrdersBetweenDateRequest, JobPostRequest, JobPostByRegistryBetweenDateRequest,
  JobOrderDetailsByOrderCodeRequest, JobRecommendsByNurseInfoOnDemandRequest, JobApplyDetailsInfoByJobPostWithNurseRequest,
  JobApplicationsInfoByRegistryRequest, JobApplicantDetailsByApplicationCodeRequest, JobApplicationForwardRequest,
  ForwardedApplicantDetailsByForwardCodeRequest,
  ForwardedApplicantsToHospitalInfoRequest,
  ReleaseOfferAndContractRequest,
  xRejectJobApplicationRequest,
  JobContractsBetweenDateRequest,
  NurseJobContractsBetweenDateRequest,
  RegistryJobContractsBetweenDateRequest,
  ShiftAllocMasterByPatternCodeWithDateRequest,
  StaffAllocInfoByShiftAllocMasterCodeRequest,
  HospitalActiveNursesInfoOnDateRequest,
  ShiftAllocMasterByCareStaffShiftTypeWithDateInfoRequest,
  StaffAttendanceInfoByShiftTypeWithDateRequest,
  StaffAttendanceInfoRequest,
  EmpNonAvailabilityCheckRequest,
  EmpNonAvailabilityRequest,
  MasterH2RContractGetRequest,
  MasterH2RContractRequest,
  AddEmployeeToResourcePoolRequest,
  GetmpEmployeeResourcePoolRequest,
  JobOpenRequest,
  JobFetchRequest,
  JobOrderRequest2,
  MasterH2RContractAddRequest,
  JobApplicantsByJobIDRequest,
  ShiftAllocationsByJobIDRequest,

  SaveShiftStatusRequest
} from '../models/hcare/hcare.model';



@Injectable({ providedIn: "root" })
export class HcareService {


  constructor(private http: HttpClient, private injector: Injector, private router: Router) {


  }
  GetParentCareUnitsInfoController(SendCareUnitInfoRequest: CareUnitInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetParentCareUnitsInfo`, (SendCareUnitInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetCareUnitByParentCodeInfoController(SendCareUnitInfoRequest: CareUnitInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetCareUnitByParentCodeInfo`, (SendCareUnitInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  SaveCareUnitInfo(SendCareUnitInfoRequest: CareUnitInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveCareUnitInfo`, (SendCareUnitInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  GetShiftAllocationsByJobID(request: ShiftAllocationsByJobIDRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocationsByJobID`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  //
  GetJobApplicantsByJobIDController(request: JobApplicantsByJobIDRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobApplicantsByJobID`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  GetEmployeeResourcePoolController(request: GetmpEmployeeResourcePoolRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetEmployeeResourcePoolController`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  SaveEmployeeResourcePoolNew(request: AddEmployeeToResourcePoolRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveEmployeeResourcePoolNew`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  SaveJobOpening(request: JobOpenRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobOpening`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  SaveShiftTypeInfo(SendShiftTypeInfoRequest: ShiftTypeInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveShiftTypeInfo`, (SendShiftTypeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetShiftTypeInfoController(SendShiftTypeInfoRequest: ShiftTypeInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftTypeInfo`, (SendShiftTypeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  SaveStaffTypeInfo(SendStaffTypeInfoRequest: StaffTypeInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveStaffTypeInfo`, (SendStaffTypeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetStaffTypeInfoController(SendStaffTypeInfoRequest: StaffTypeInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetStaffTypeInfo`, (SendStaffTypeInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  /////////////////-----------------------
  SaveShiftAllocPatternInfo(SendShiftAllocPatternRequest: ShiftAllocPatternRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveShiftAllocPatternInfo`, (SendShiftAllocPatternRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  GetShiftAllocPatternByCareUnitInfoController(SendShiftAllocPatternRequest: ShiftAllocPatternRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocPatternByCareUnitInfo`, (SendShiftAllocPatternRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetShiftAllocPatternInfoController(SendShiftAllocPatternRequest: ShiftAllocPatternRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocPatternInfo`, (SendShiftAllocPatternRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  SaveShiftAllocMasterInfo(SendShiftAllocMasterRequest: ShiftAllocMasterRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveShiftAllocMasterInfo`, (SendShiftAllocMasterRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetShiftAllocMasterByDateInfoController(SendShiftAllocMasterRequest: ShiftAllocMasterRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocMasterByDateInfo`, (SendShiftAllocMasterRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  SaveJobOrderRequest2(request: JobOrderRequest2) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobOrderRequest2`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
    );
  }
  //GetShiftAllocPatternsInfoController(SendShiftAllocPatternRequest: ShiftAllocPatternRequest) {
  //  return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocPatternsInfo`, (SendShiftAllocPatternRequest),
  //    {
  //      headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
  //    }
  //  ).pipe(
  //    catchError(this.handleError)
  //    );
  //}
  //---------------
  SaveShiftStatus(SaveShiftStatusRequest: SaveShiftStatusRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveShiftStatus`, (SaveShiftStatusRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  SaveShiftAllocationInfo(SendShiftAllocationRequest: ShiftAllocationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveShiftAllocationInfo`, (SendShiftAllocationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  

  GetShiftAllocationByDateInfoController(SendShiftAllocationRequest: ShiftAllocationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocationByDateInfo`, (SendShiftAllocationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  SaveResourceIdentificationInfo(SendJobIdentificationRequest: JobIdentificationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveResourceIdentificationInfo`, (SendJobIdentificationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //============================
  GetJobOpenings(request: JobFetchRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobOpenings`, (request),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  GetResourceIdentificationByDateInfoController(SendJobIdentificationRequest: JobIdentificationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetResourceIdentificationByDateInfo`, (SendJobIdentificationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  SaveResourceOrderPostInfo(SendJobOrderRequest: JobOrderRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveResourceOrderPostInfo`, (SendJobOrderRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetResourceOrdersByJobIDInfoController(SendJobOrderRequest: JobOrderRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetResourceOrdersByJobIDInfo`, (SendJobOrderRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetJobOrdersBetweenDatesInfoController(SendJobOrdersBetweenDateRequest: JobOrdersBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobOrdersBetweenDatesInfo`, (SendJobOrdersBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  GetOrdersByRegistryBetweenDatesInfoController(SendRegistryOrdersBetweenDateRequest: RegistryOrdersBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetOrdersByRegistryBetweenDatesInfo`, (SendRegistryOrdersBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  GetJobOrderDetailsByOrderCodeInfoController(SendJobOrderDetailsByOrderCodeRequest: JobOrderDetailsByOrderCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobOrderDetailsByOrderCodeInfo`, (SendJobOrderDetailsByOrderCodeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  SaveJobPostInfo(SendJobPostRequest: JobPostRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobPostInfo`, (SendJobPostRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  GetJobPostInfoByRegistryBetweenDateController(SendJobPostByRegistryBetweenDateRequest: JobPostByRegistryBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobPostInfoByRegistryBetweenDate`, (SendJobPostByRegistryBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------------
  GetJobRecommendsByNurseInfoOnDemandController(SendJobRecommendsByNurseInfoOnDemandRequest: JobRecommendsByNurseInfoOnDemandRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobRecommendsByNurseInfoOnDemand`, (SendJobRecommendsByNurseInfoOnDemandRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //----------
  GetJobApplyDetailsInfoByJobPostWithNurseController(SendJobApplyDetailsInfoByJobPostWithNurseRequest: JobApplyDetailsInfoByJobPostWithNurseRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobApplyDetailsInfoByJobPostWithNurse`, (SendJobApplyDetailsInfoByJobPostWithNurseRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //-------------------------------------------------------------------------------------------------------------------------
  GetJobApplicationsInfoByRegistryOnDemandController(SendJobApplicationsInfoByRegistryRequest: JobApplicationsInfoByRegistryRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobApplicationsInfoByRegistryOnDemand`, (SendJobApplicationsInfoByRegistryRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //----------
  GetJobApplicantDetailsByApplicationCodeController(SendJobApplicantDetailsByApplicationCodeRequest: JobApplicantDetailsByApplicationCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobApplicantDetailsByApplicationCode`, (SendJobApplicantDetailsByApplicationCodeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  SaveJobApplicationInfo(SendJobApplicationRequest: JobApplicationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobApplicationInfo`, (SendJobApplicationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetJobApplicationsByJobPostInfoController(SendJobApplicationRequest: JobApplicationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobApplicationsByJobPostInfo`, (SendJobApplicationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //---------------
  SaveJobApplicationTrackInfo(SendJobApplicationTrackRequest: JobApplicationTrackRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobApplicationTrackInfo`, (SendJobApplicationTrackRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetJobAppTrackByAppCodeInfoController(SendJobApplicationTrackRequest: JobApplicationTrackRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobAppTrackByAppCodeInfo`, (SendJobApplicationTrackRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  SaveJobApplicationForwordInfo(SendJobApplicationForwardRequest: JobApplicationForwardRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobApplicationForwordInfo`, (SendJobApplicationForwardRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  GetForwardedApplicantsToHospitalInfoOnDemandController(SendForwardedJobsToHospitalInfoRequest: ForwardedApplicantsToHospitalInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetForwardedApplicantsToHospitalInfoOnDemand`, (SendForwardedJobsToHospitalInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  GetForwardedApplicantDetailsByForwardCodeController(SendForwardedApplicantDetailsByForwardCodeRequest: ForwardedApplicantDetailsByForwardCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetForwardedApplicantDetailsByForwardCode`, (SendForwardedApplicantDetailsByForwardCodeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  SaveJobOfferInfo(SendJobOfferRequest: JobOfferRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveJobOfferInfo`, (SendJobOfferRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //---------------
  xReleaseJobOfferAndContract(SendReleaseOfferAndContractRequest: ReleaseOfferAndContractRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/xReleaseJobOfferAndContract`, (SendReleaseOfferAndContractRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetJobOfferByJobPostInfoController(SendJobOfferRequest: JobOfferRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobOfferByJobPostInfo`, (SendJobOfferRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  GetJobOfferByJobCodeInfoController(SendJobOfferRequest: JobOfferRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobOfferByJobCodeInfo`, (SendJobOfferRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  xRejectJobApplication(SendxRejectJobApplicationRequest: xRejectJobApplicationRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/xRejectJobApplication`, (SendxRejectJobApplicationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  GetJobContractsBetweenDatesInfoController(SendJobContractsBetweenDateRequest: JobContractsBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetJobContractsBetweenDatesInfo`, (SendJobContractsBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  GetRegistryJobContractsBetweenDatesInfoController(SendRegistryJobContractsBetweenDateRequest: RegistryJobContractsBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetRegistryJobContractsBetweenDatesInfo`, (SendRegistryJobContractsBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  GetNurseJobContractsBetweenDatesInfoController(SendNurseJobContractsBetweenDateRequest: NurseJobContractsBetweenDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetNurseJobContractsBetweenDatesInfo`, (SendNurseJobContractsBetweenDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }




  GetShiftAllocMasterByPatternCodeWithDateInfoController(SendShiftAllocMasterByPatternCodeWithDateRequest: ShiftAllocMasterByPatternCodeWithDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocMasterByPatternCodeWithDateInfo`, (SendShiftAllocMasterByPatternCodeWithDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetStaffAllocInfoByShiftAllocMasterCodeController(SendStaffAllocInfoByShiftAllocMasterCodeRequest: StaffAllocInfoByShiftAllocMasterCodeRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetStaffAllocInfoByShiftAllocMasterCode`, (SendStaffAllocInfoByShiftAllocMasterCodeRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }
  //
  GetHospitalActiveNursesInfoOnDateController(SendHospitalActiveNursesInfoOnDateRequest: HospitalActiveNursesInfoOnDateRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetHospitalActiveNursesInfoOnDate`, (SendHospitalActiveNursesInfoOnDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetShiftAllocMasterByCareStaffShiftTypeWithDateInfoController(SendShiftAllocMasterByCareStaffShiftTypeWithDateInfoRequest: ShiftAllocMasterByCareStaffShiftTypeWithDateInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetShiftAllocMasterByCareStaffShiftTypeWithDateInfo`, (SendShiftAllocMasterByCareStaffShiftTypeWithDateInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetStaffAttendanceInfoByShiftTypeWithDateController(SendStaffAttendanceInfoByShiftTypeWithDateRequest: StaffAttendanceInfoByShiftTypeWithDateRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetStaffAttendanceInfoByShiftTypeWithDate`, (SendStaffAttendanceInfoByShiftTypeWithDateRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  //---------------
  SaveStaffAttendanceInfo(SendStaffAttendanceInfoRequest: StaffAttendanceInfoRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveStaffAttendanceInfo`, (SendStaffAttendanceInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetEmpNonAvailabilityController(EmpNonAvailabilityCheckRequest: EmpNonAvailabilityCheckRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetEmpNonAvailability`, (EmpNonAvailabilityCheckRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  //---------------
  SaveEmpNonAvailability(EmpNonAvailabilityRequest: EmpNonAvailabilityRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveEmpNonAvailability`, (EmpNonAvailabilityRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }

  //
  GetMasterH2RContractController(MasterH2RContractGetRequest: MasterH2RContractGetRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/GetMasterH2RContract`, (MasterH2RContractGetRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  //---------------
  SaveMasterH2RContract(MasterH2RContractRequest: MasterH2RContractAddRequest) {
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Hcare/SaveMasterH2RContract`, (MasterH2RContractRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(
      catchError(this.handleError)
      );
  }


  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
